export default "__VITE_ASSET__BoOQdcfe__"